
const History = require('../wiring/history');
const { context } = require('../app-context');
const Storage = require('utils/storage');
const PersistenceConfig = require('utils/persistence-config');

const internals = {};

module.exports = (store) => {

    const actions = context.actions;
    const redux = context.redux.hooks;

    internals.installWindowLocationLogger();

    let previousPathname = '/';
    let previousHref = internals.getWindowHref();

    History.listen((location, action) => {

        const currentPathname = location.pathname;
        const currentHref = internals.getLocationHref(location);

        internals.recordLocationChange({
            source: 'history.listen',
            action,
            from: previousHref,
            to: currentHref,
            location
        });

        redux.dispatch(actions.app.setHistoryPreviousPathname({ pathname: previousPathname }));
        // Set for next history change
        previousPathname = currentPathname;
        previousHref = currentHref;
        redux.dispatch(actions.app.setHistoryPathname({ pathname: currentPathname }));
    });
};

internals.installWindowLocationLogger = () => {

    if (typeof window === 'undefined' || window.__nearpeerLocationLoggerInstalled) {
        return;
    }

    window.__nearpeerLocationLoggerInstalled = true;

    let previousHref = internals.getWindowHref();

    const recordWindowLocation = (source, details = {}) => {

        const currentHref = internals.getWindowHref();

        internals.recordLocationChange({
            source,
            from: previousHref,
            to: currentHref,
            ...details
        });

        previousHref = currentHref;
    };

    ['pushState', 'replaceState'].forEach((method) => {

        const original = window.history?.[method];

        if (typeof original !== 'function') {
            return;
        }

        window.history[method] = function nearpeerLoggedHistoryChange(...args) {

            const result = original.apply(this, args);

            recordWindowLocation(`window.history.${method}`, {
                state: args[0] || null,
                title: args[1] || null,
                url: args[2] ? internals.sanitizeHref(args[2]) : null
            });

            return result;
        };
    });

    window.addEventListener('popstate', () => recordWindowLocation('window.popstate'));
    window.addEventListener('hashchange', () => recordWindowLocation('window.hashchange'));
    window.addEventListener('beforeunload', () => recordWindowLocation('window.beforeunload'));
};

internals.recordLocationChange = ({
    source,
    action,
    from,
    to,
    location,
    state,
    title,
    url
} = {}) => {

    if (typeof window === 'undefined') {
        return;
    }

    const entry = {
        at: new Date().toISOString(),
        source,
        action: action || null,
        from: internals.sanitizeHref(from),
        to: internals.sanitizeHref(to),
        windowHref: internals.getWindowHref(),
        pathname: location?.pathname || window.location.pathname,
        search: internals.sanitizeSearch(location?.search || window.location.search),
        hash: location?.hash || window.location.hash,
        state: state || location?.state || null,
        title: title || null,
        url: url || null
    };

    const current = window.__nearpeerLocationDebug || {};
    const recent = [entry].concat(current.recent || []).slice(0, 50);

    window.__nearpeerLocationDebug = {
        ...current,
        ...entry,
        recent
    };

    try {
        Storage.setItem(PersistenceConfig.keys.debug.navigation, JSON.stringify(recent));
    }
    catch (err) {}

    console.info('[navigation] window location changed', entry);
};

internals.getLocationHref = (location = {}) => internals.sanitizeHref(
    `${location.pathname || ''}${location.search || ''}${location.hash || ''}`
);

internals.getWindowHref = () => {

    if (typeof window === 'undefined') {
        return '';
    }

    return internals.sanitizeHref(window.location.href);
};

internals.sanitizeHref = (href = '') => {

    if (typeof href !== 'string') {
        return href;
    }

    try {
        const url = new URL(href, typeof window === 'undefined' ? 'https://nearpeer.local' : window.location.origin);

        ['code', 'token', 'access_token', 'id_token', 'refresh_token'].forEach((key) => {

            if (url.searchParams.has(key)) {
                url.searchParams.set(key, '[redacted]');
            }
        });

        return `${url.pathname}${url.search}${url.hash}`;
    }
    catch (err) {
        return href;
    }
};

internals.sanitizeSearch = (search = '') => {

    if (!search) {
        return '';
    }

    return internals.sanitizeHref(`/${search}`).replace(/^\//, '');
};
